import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {renderTextField} from '../../common/RenderFields'
import _ from 'lodash'

class CreateGroupForm extends Component {

    render() {
        const { handleSubmit } = this.props;
        //console.log('CreateGroupForm', this.props)

        return (
            <form onSubmit={handleSubmit}>

                <div className="modal-content-body">
                    <div>
                        <label htmlFor="name">Name</label>
                    </div>
                    <div>
                        <Field className="body-field" name="name" inputClass="input-wide" component={renderTextField} />
                    </div>
                    {/*<div>
                        <label htmlFor="email">Email</label>
                    </div>
                    <div>
                        <Field className="body-field" name="email" inputClass="input-wide" component={renderTextField} />
                    </div>*/}

                    <div className="create-group-buttons">
                        <button className='submit create-group-submit' type="submit">Create</button>
                        <button className="link no-underline" onClick={this.props.onCancel}>Cancel</button>
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values) => {
    const errors = {}

    _.forEach([
        'name'], k => {
        if (!values[k]) {
            errors[k] = 'Required'
        }
    })

    return errors
}

CreateGroupForm = reduxForm({
    form: 'createGroupForm',
    validate
})(CreateGroupForm);

export default CreateGroupForm


// WEBPACK FOOTER //
// ./src/components/admin/groups/CreateGroupForm.jsx